"use strict";
/**
 * Redux-form utilities
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCurrencyStringToNumber = exports.parseStringToNumber = exports.formatDecimalsToCurrency = void 0;
/**
 * Format decimals to currency
 * For example, 1020 -> 10.20
 * - Empty string if value is missing
 *  */
const formatDecimalsToCurrency = (value) => (typeof value === 'number' ? value / 100 : '');
exports.formatDecimalsToCurrency = formatDecimalsToCurrency;
/**
 * Parse string to number to redux store.
 * - null if empty value.
 * */
const parseStringToNumber = (value) => value !== '' && value !== undefined && value !== null ? parseFloat(value) : null;
exports.parseStringToNumber = parseStringToNumber;
const roundByTwoDecimals = (value) => Math.round(value * 100) / 100;
/**
 * Round given price (in cents) to prevent multiplied price with weird decimals to be stored in db.
 * - E.g 19.90 * 100 = 1989.9999999999998
 * @example const price = 1989.9999999999998
 * const roundedPrice = roundCents(price)
 * => // 1990
 * @param value
 * @returns
 */
const roundCents = (value) => Math.round(value * 100 + Number.EPSILON) / 100;
/**
 * Parse price to decimals to redux store.
 * - Allow only two decimals.
 * - null if empty value.
 */
const parseCurrencyStringToNumber = (value) => value !== '' && value !== undefined && value !== null
    ? roundCents(roundByTwoDecimals(parseFloat(value)) * 100)
    : null;
exports.parseCurrencyStringToNumber = parseCurrencyStringToNumber;
//# sourceMappingURL=formValues.js.map